import React from 'react';
import { styled } from '@mui/material';

import { Box, Button, Icon, Link, Stack, Text } from 'shell/components';
import { useViewport } from 'contexts/viewport';

const TourTooltip = ({
    continuous,
    index,
    step,
    numSteps,
    backProps,
    link,
    primaryProps,
    title,
    description,
    image,
    tooltipProps,
    hideButtons,
    sx,
}) => {
    const { device } = useViewport();
    return (
        <TooltipBody sx={sx} {...tooltipProps}>
            <Stack spacing={3}>
                <Stack alignItems={'flex-end'} direction={'row'} spacing={3}>
                    <TextStack sx={{ textAlign: 'left' }} spacing={2}>
                        <Text color={'inherit'} variant={'p3'}>{`${index + 1} of ${numSteps}`}</Text>
                        <Text color={'inherit'} variant={'h6'}>
                            {title}
                        </Text>
                        <Text color={'inherit'} variant={'p2'}>
                            {description}
                        </Text>
                    </TextStack>
                    {device !== 'mobile' && image && <Stack>{image}</Stack>}
                </Stack>
                <TooltipFooter alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Stack>
                        {link && (
                            <Link
                                sx={{ color: '#FAFAFB', '&:hover': { color: '#FAFAFB' } }}
                                external
                                rel={'noopener noreferrer'}
                                target={'_blank'}
                                href={link.url}
                                startIcon={<Icon kind={'video'} />}
                                variant={'neutral'}
                            >
                                {link.text}
                            </Link>
                        )}
                    </Stack>
                    <Stack direction={'row'} spacing={4}>
                        {!step.hideBackButton && index > 0 && (
                            <CustomBackButton variant={'tertiary'} {...backProps}>
                                Back
                            </CustomBackButton>
                        )}
                        {!hideButtons?.next && continuous && (
                            <CustomNextButton variant={'secondary'} {...primaryProps}>
                                {step.locale.next}
                            </CustomNextButton>
                        )}
                    </Stack>
                </TooltipFooter>
            </Stack>
        </TooltipBody>
    );
};

const TooltipBody = styled(Box)(({ theme }) => {
    return {
        padding: theme.spacing(6, 5),
        background: theme.palette.ensightful.primary[500],
        borderRadius: theme.spacing(2),
    };
});

const TextStack = styled(Stack)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[50],
    };
});

const TooltipFooter = styled(Stack)(() => {
    return {};
});

const CustomBackButton = styled(Button)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[50],

        '&:hover': {
            color: theme.palette.ensightful.neutral[50],
        },
    };
});

const CustomNextButton = styled(Button)(({ theme }) => {
    return {
        background: theme.palette.ensightful.neutral[50],

        '&:hover': {
            background: theme.palette.ensightful.neutral[50],
        },
    };
});

export default TourTooltip;
